import { breakpointValues } from '../styles/globalStyleVars';

export interface BreakpointConfigProps {
  [key: string]: number;
  xs: number;
  sm: number;
  md: number;
  lg: number;
  xl: number;
  xxl: number;
}

const DEFAULT_BREAKPOINTS: BreakpointConfigProps = { ...breakpointValues };

const OFFSET = 0.02;

function createBreakpoints(breakpoints: BreakpointConfigProps) {
  const sortedEntries = Object.entries(breakpoints).sort(
    ([, a], [, b]) => a - b
  );
  const values = Object.fromEntries(sortedEntries) as BreakpointConfigProps;
  const keys = sortedEntries.map(
    ([key]) => key
  ) as (keyof BreakpointConfigProps)[];

  function up(key: keyof BreakpointConfigProps): string {
    return `(min-width:${breakpoints[key]}px)`;
  }

  function down(key: keyof BreakpointConfigProps): string {
    return `(max-width:${breakpoints[key] - OFFSET}px)`;
  }

  function between(
    start: keyof BreakpointConfigProps,
    end: keyof BreakpointConfigProps
  ): string {
    return `(min-width:${breakpoints[start]}px) and (max-width:${
      breakpoints[end] - OFFSET
    }px)`;
  }

  function only(key: keyof BreakpointConfigProps): string {
    const idx = keys.indexOf(key);
    if (idx + 1 < keys.length) {
      return between(key, keys[idx + 1]);
    }
    return up(key);
  }

  return { keys, values, up, down, between, only };
}

export default function useBreakpoints() {
  return createBreakpoints(DEFAULT_BREAKPOINTS);
}
